//@ts-strict-ignore
import React from 'react';
import styled from 'styled-components';

const textPosition = ({ position, theme }) => {
  switch (position) {
    case 'bottom-left':
      return `
        bottom: 100%;
        left: .375rem;
        border-bottom: .375rem solid ${theme.colors.tooltipBackground};
        border-right: .375rem solid transparent;
        border-left: .375rem solid transparent;
        margin-left: 6.25rem;
      `;
    case 'view-toolbar':
      return `
        bottom: 100%;
        left: .375rem;
        border-bottom: .375rem solid ${theme.colors.tooltipBackground};
        border-right: .375rem solid transparent;
        border-left: .375rem solid transparent;
        margin-left: 6.25rem;
      `;
    case 'right':
      return `
        right: 100%;
        top: .5rem;
        bottom: 0;
        left: 0;
        margin-left: -.375rem;
        border-right: .375rem solid ${theme.colors.tooltipBackground};
        border-top: .375rem solid transparent;
        border-bottom: .375rem solid transparent;
        border-left: none;
      `;
    case 'left':
      return `
        right: 0;
        top: .5rem;
        bottom: 0;
        left: 100%;
        margin-right: -.375rem;
        border-left: .375rem solid ${theme.colors.tooltipBackground};
        border-top: .375rem solid transparent;
        border-bottom: .375rem solid transparent;
        border-right: none;
      `;
    case 'appicon':
      return `
        right: 100%;
        top: .5rem;
        bottom: 0;
        left: 0;
        margin-left: -.375rem;
        border-right: .375rem solid ${theme.colors.tooltipBackground};
        border-top: .375rem solid transparent;
        border-bottom: .375rem solid transparent;
        border-left: none;
      `;
    default:
      return `
        bottom: 100%;
        left: .375rem;
        border-bottom: .375rem solid ${theme.colors.tooltipBackground};
        border-right: .375rem solid transparent;
        border-left: .375rem solid transparent;
      `;
  }
};

const divPosition = ({ position }: { position?: string }) => {
  switch (position) {
    case 'bottom-left':
      return `
        top: 0;
        margin-top: 34px;
        left: -5.125rem;
      `;
    case 'view-toolbar':
      return `
        top: 0;
        margin-top: 34px;
        left: -5.5rem;
      `;
    case 'right':
      return `
        top: 0rem;
        left: 2.5rem;
        margin-top: 0;
      `;
    case 'left':
      return `
        top: -.125rem;
        left: -9.25rem;
        margin-top: 0;
      `;
    case 'appicon':
      return `
        top: 0px;
        left: 2.375rem;
        margin-top: 0;
      `;
    case 'wideappicon': //Shift below rather than to right due to wider icon.
      return `
        top: 42px;
        left: 10px;
        margin-top: 0;
      `;
    default:
      return `
        top: 0;
        left: 1.25rem;
        margin-top: 34px;
      `;
  }
};

const Text = styled.div`
  &:after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    ${textPosition};
    z-index: 1000000;
  }
`;

const Div = styled.div`
  position: absolute;
  min-width: 8.75rem;
  color: ${(props) => props.theme.colors.tooltipText};
  background-color: ${(props) => props.theme.colors.tooltipBackground};
  padding: 0.25rem 0.25rem;
  text-align: center;
  border-radius: 0rem;
  font-size: 12px;
  z-index: 1000000;
  ${divPosition};
`;

type TooltipProps = {
  value: any;
  position?: string;
  style?: any;
};

/**
 * @deprecated - Please use the fluent-ui Tooltip component instead.
 * https://react.fluentui.dev/?path=/docs/components-tooltip--docs
 *
 * Note that the fluent-ui Tooltip does not require a 'TriggerPopover' wrapper so care should be taken in migrating code.
 *
 */
const DeprecatedTooltip = ({ value, position, style }: TooltipProps) => {
  if (!value) return null;
  return (
    <Div key="tooltip" position={position} style={style}>
      <Text position={position}>{value}</Text>
    </Div>
  );
};

export default DeprecatedTooltip;
